import React, { useState, useEffect } from 'react';
import { Tooltip, SvgIcon } from '@material-ui/core';
import { Link } from 'react-router';
import { getGlobalCookie, setGlobalCookie, getLocalStorageInfo } from '../../utils';
const DoubleArrowLeftIcon = (props) => <SvgIcon {...props}><path d="M17.59 18 19 16.59 14.42 12 19 7.41 17.59 6l-6 6z" /><path d="M11 18l1.41-1.41L7.83 12l4.58-4.59L11 6l-6 6z" /></SvgIcon>;
// every hook instance on the same key stays in sync, so a page can react to its nav being toggled
const collapseListeners = {};
export const useSideNavCollapse = (storageKey) => {
    const { user, defaultLessor } = getLocalStorageInfo() || {};
    const cookieKey = `${storageKey}_${user?.id}_${defaultLessor?.id}`;
    const [collapsed, setCollapsed] = useState(getGlobalCookie(cookieKey) === 'true');
    useEffect(() => {
        const listeners = collapseListeners[cookieKey] = collapseListeners[cookieKey] || new Set();
        listeners.add(setCollapsed);
        return () => listeners.delete(setCollapsed);
    }, [cookieKey]);
    const toggleNav = () => {
        setGlobalCookie(cookieKey, String(!collapsed), 60);
        collapseListeners[cookieKey].forEach(setValue => setValue(!collapsed));
    }
    return [collapsed, toggleNav];
}
// height taken by the page title shown above the content while the nav is collapsed;
// subtract it from listing heights that are computed from window.innerHeight
export const NAV_PAGE_TITLE_HEIGHT = 30;
export const usePageTitleOffset = (storageKey) => useSideNavCollapse(storageKey)[0] ? NAV_PAGE_TITLE_HEIGHT : 0;
// navItems: [{ label, to, icon, show, active? }] - pass `active` to override router based highlighting
// Pass collapsed + onToggle when the parent needs the state (e.g. to style a wrapper)
// showPageTitle: when collapsed, show the active item's label above the content (render the nav right before .tech-specs-content)
const CollapsibleSideNav = ({ storageKey, navItems, collapsed: controlledCollapsed, onToggle, showPageTitle }) => {
    const [ownCollapsed, ownToggle] = useSideNavCollapse(storageKey);
    const collapsed = controlledCollapsed !== undefined ? controlledCollapsed : ownCollapsed;
    const toggleNav = onToggle || ownToggle;
    const activeItem = navItems.find(item => item.show && item.active);
    return (
        <>
        <div className={`tech-specs-nav ${collapsed ? 'collapsed' : ''}`}>
            <div className='tech-nav-toggle-row'>
                <Tooltip title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'} arrow placement='right'>
                    <button type='button' className='tech-nav-toggle' onClick={toggleNav}>
                        <DoubleArrowLeftIcon />
                    </button>
                </Tooltip>
            </div>
            <div className='tech-nav-links'>
                {navItems.filter(item => item.show).map(({ label, to, icon: Icon, active }) =>
                    <Tooltip key={to} title={collapsed ? label : ''} arrow placement='right'>
                        <div className='tech-nav-link'>
                            <Link to={to} {...(active !== undefined ? { className: active ? 'active' : '' } : { activeClassName: 'active' })}>
                                <Icon className='tech-nav-icon' />
                                <span className='tech-nav-label'>{label}</span>
                            </Link>
                        </div>
                    </Tooltip>
                )}
            </div>
        </div>
        {showPageTitle && collapsed && activeItem ?
            <h4 className='tech-nav-page-title'>{activeItem.label}</h4> : null
        }
        </>
    )
}
export default CollapsibleSideNav
